import { Building2, Calendar, Clock, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SoftButton } from '@/ui/design-system'

import {
  CardTypeBadge,
  Thumbnail,
  formatCarteCapacity,
  formatHourRange,
  formatPeriode,
  formatTND,
} from '../shared'

const Meta = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-1.5 text-xs text-[var(--muted-foreground)]">
    <Icon className="h-3.5 w-3.5 text-[var(--muted-foreground)]" aria-hidden />
    {children}
  </span>
)

const ResultListItem = ({ carte, onReserve }) => {
  const { t } = useTranslation()
  const image = carte.images?.find((i) => i.active)?.url
  return (
    <article className="flex items-center gap-4 rounded-[var(--radius-md)] border border-[var(--border)] bg-[var(--card)] p-4 shadow-[var(--shadow-sm)] transition hover:shadow-[var(--shadow-md)]">
      <Thumbnail src={image} alt={carte.label} className="h-20 w-20 shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate text-sm font-semibold text-[var(--foreground)]">{carte.label}</h3>
          <CardTypeBadge type={carte.type} />
        </div>
        <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
          <Meta icon={Building2}>{carte.facility_label}</Meta>
          <Meta icon={Calendar}>{formatPeriode(carte.start_date, carte.end_date)}</Meta>
          <Meta icon={Clock}>{formatHourRange(carte.start_hour, carte.end_hour)}</Meta>
          <Meta icon={Users}>{formatCarteCapacity(carte, t)}</Meta>
        </div>
      </div>
      <div className="shrink-0 text-right">
        <p className="moteur-ui-price text-base font-bold text-[var(--color-primary-700)] font-[family-name:var(--font-mono)] tabular-nums">
          {formatTND(carte.price)}
        </p>
        <p className="mb-2 text-xs text-[var(--muted-foreground)]">
          {t('cartesAcces.recherche.result.conso', { amount: formatTND(carte.price_consumption) })}
        </p>
        <SoftButton variant="soft" size="sm" onClick={() => onReserve(carte)}>
          {t('cartesAcces.recherche.result.reserve')}
        </SoftButton>
      </div>
    </article>
  )
}

export default ResultListItem
